import React from 'react'
import useImport from '../../import'
import InfoNote from '../../InfoNote'

const resultMap = {
  entities: 'addresses in store',
  updated: 'addresses updated',
  created: 'addresses created',
  deleted: 'addresses deleted',
}

const CustomerAddressesImport = () => {
  const { FileSelector, FileImport, result, fileSelected, disabled } =
    useImport({
      event: 'Customer addresses import',
      method: 'customer-addresses/import',
      resultMap,
    })

  return (
    <>
      {!result?.runId && !fileSelected && (
        <>
          <FileSelector disabled={disabled} />

          <div className="rounded-md opacity-70 mt-auto pt-4">
            <InfoNote title="Won't delete">
              Import process <em>will not</em>&nbsp;delete any addresses.
              We plan to build a tool to help you delete addresses. If you need this sooner rather than later, let us know!
            </InfoNote>
            <InfoNote title="Have a backup?">
              Make sure you have a{' '}
              <span className="font-bold">recent, unmodified CSV file</span> in
              case you need to restore your data.{' '}
            </InfoNote>
          </div>
        </>
      )}

      {(result?.runId || fileSelected) && <FileImport />}
    </>
  )
}

export default CustomerAddressesImport
